import Accordion from './accordion/accordion';
import Brochure from './brochure/brochure';
import ButtonGroup from './button-group/button-group';
import Button from './button/button';
import CardRounded from './card-rounded/card-rounded';
import CardStats from './card-stats/card-stats';
import Card from './card/card';
import CardSimple from './card-simple/card-simple';
import CardLogo from './card-logo/card-logo';
import CardAlt from './card-alt/card-alt';
import CardSm from './card-sm/card-sm';
import CardLinks from './card-links/card-links';
import CardListIcon from './card-list-icon/card-list-icon';
import Carousel from './carousel/carousel';
import Carousel2 from './carousel2/carousel2';
import Heading from './heading/heading';
import Lang from './lang/lang';
import MenuCustom from './menu-custom/menu-custom';
import MenuSocial from './menu-social/menu-social';
import Menu from './menu/menu';
import NavResponsive from './nav-responsive/nav-responsive';
import Nav from './nav/nav';
import PageTop from './page-top/page-top';
// import Posts from './posts/posts';
import RibbonSeparator from './ribbon/ribbonSeparator';
import Search from './search/search';
import Social from './social/social';
import Timeline from './timeline/timeline';
import Image from './image/image';
import Icon from './icon/icon';
import List from './list/list';
import Gallery from './gallery/gallery';
import Adverts from './adverts/adverts';
import Tabs from './tabs/tabs';
import Table from './table/table';
import Video from './video/video';
import ButtonService from './button-service/button-service';
import Newsletter from './newsletter/newsletter';
import PostTop from './post-top/post-top';
import Paragraph from './paragraph/paragraph';
import Documents from './documents/documents';
import News from './news/news';
import Projects from './projects/projects';
import SiteLogo from './site-logo/site-logo';
import CardStatsLg from './card-stats-lg/card-stats-lg';
import OsMap from './os-map/os-map';
import SearchResults from './search-results/search-results';
import CardLink from './card-link/card-link';
import GreenKilometers from './green-kilometers/green-kilometers';
import Forminator from './forminator/forminator';
import Events from './events/events';
import EventsTop from './events-top/events-top';
import VideoHero from './video-hero/video-hero';
import Iframe from './iframe/iframe';
import VirtualTour from './virtual-tour/virtual-tour';
import Tvarumas from './tvarumas/tvarumas';
import TvarumasCategories from './tvarumas-categories/tvarumas-kategorijos';
import RouteLengthCalculator from './route-length-calculator/route-length-calculator';
export const widgets = {
    'ltg-site-logo': SiteLogo,
    'card-clipped': Card,
    'ltg-card-simple': CardSimple,
    'ltg-card-logo': CardLogo,
    'ltg-card-links': CardLinks,
    'ltg-card-alt': CardAlt,
    'ltg-card-sm': CardSm,
    'ltg-card-list-icon': CardListIcon,
    'ltg-card-rounded': CardRounded,
    'ltg-carousel': Carousel,
    'ltg-carousel2': Carousel2,
    'ltg-gallery': Gallery,
    "ltg-green-kilomenters": GreenKilometers,
    // 'ltg-posts':Posts,
    'ltg-button': Button,
    'ltg-button-service': ButtonService,
    'ltg-brochure': Brochure,
    'ltg-ribbon': RibbonSeparator,
    'ltg-nav': Nav,
    'ltg-nav-responsive': NavResponsive,
    'ltg-menu': Menu,
    'ltg-menu-custom': MenuCustom,
    'ltg-menu-social': MenuSocial,
    'ltg-social': Social,
    'ltg-lang': Lang,
    'ltg-search': Search,
    'ltg-page-top': PageTop,
    'ltg-card-stats': CardStats,
    'ltg-card-stats-lg': CardStatsLg,
    'ltg-heading': Heading,
    'ltg-button-group': ButtonGroup,
    'ltg-timeline': Timeline,
    'ltg-accordion': Accordion,
    'ltg-image': Image,
    'ltg-icon': Icon,
    'ltg-list': List,
    'ltg-adverts': Adverts,
    'ltg-tabs': Tabs,
    'ltg-table': Table,
    'ltg-video': Video,
    'ltg-os-map': OsMap,
    // 'ltg-os-map':OsMap,
    'ltg-newsletter': Newsletter,
    'ltg-post-top': PostTop,
    'ltg-paragraph': Paragraph,
    'ltg-documents': Documents,
    'ltg-news': News,
    'ltg-events': Events,
    'ltg-events-top': EventsTop,
    'ltg-projects': Projects,
    'ltg-search-results': SearchResults,
    'ltg-card-link': CardLink,
    'ltg-forminator': Forminator,
    'ltg-video-hero': VideoHero,
    'ltg-iframe': Iframe,
    'ltg-virtual-tour': VirtualTour,
    'ltg-tvarumas': Tvarumas,
    'ltg-tvarumas-categories': TvarumasCategories,
    "ltg-route-length-calculator": RouteLengthCalculator,
};
